import { EnvironmentProviders, inject } from '@angular/core';
import { TrackWorkflowService, provideWorkflowTracking } from '@anduin/shared';
import {
  EMAIL_DELIVERY_STEP_TO_EVENT_TYPE,
  EMAIL_DELIVERY_STEP_TO_WORKFLOW,
  EmailDeliveryWorkflowStep,
  EmailDeliveryWorkflowStepMetaDataMap,
} from './email-delivery-workflow.models';

/**
 * Strongly-typed `TrackWorkflowService` view for the email-delivery-hub module.
 * `trackWorkflow` narrows `metadata` to the shape declared on
 * `EmailDeliveryWorkflowStepMetaDataMap` for whatever step the caller passes.
 */
export type EmailDeliveryTracker = TrackWorkflowService<EmailDeliveryWorkflowStep, EmailDeliveryWorkflowStepMetaDataMap>;

/**
 * Inject the workflow tracker narrowed to the email-delivery-hub taxonomy. Use this in
 * place of `inject(TrackWorkflowService)` anywhere in the module that needs
 * `trackWorkflow` — direct injection of `TrackWorkflowService` is blocked by
 * `no-restricted-imports` (see `eslint.config.js`).
 */
export function injectEmailDeliveryTracking(): EmailDeliveryTracker {
  return inject(TrackWorkflowService) as EmailDeliveryTracker;
}

/**
 * Register the email-delivery-hub module's workflow taxonomy. Call once at app providers so
 * `trackWorkflow(<email-delivery step>)` resolves at runtime against the shared
 * `TrackWorkflowService`.
 */
export function provideEmailDeliveryWorkflowTracking(): EnvironmentProviders {
  return provideWorkflowTracking<EmailDeliveryWorkflowStep, EmailDeliveryWorkflowStepMetaDataMap>({
    stepToWorkflow: EMAIL_DELIVERY_STEP_TO_WORKFLOW,
    stepToEventType: EMAIL_DELIVERY_STEP_TO_EVENT_TYPE,
  });
}
